module.exports = {"header_path_one":"Beginnen Sie mit E-Mail und Passwort","header_path_two":"Geben Sie Handy-Nummer","header_path_three":"Bestätigen Sie Ihre Angaben"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/screens.json
// module id = 500
// module chunks = 248 1668